import React, { useRef, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const GOOGLE_MAPS_API_KEY = "AIzaSyC1uoo4vup8ru86BZSEhh-w7VAAi_LmQ9M";

const GooglePlacesInputComponent = ({
  label = "Location",
  value,
  onChange,
  error,
  required = false,
}) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [locationData, setLocationData] = useState(null);

  const getAddressFromValue = () => {
    if (typeof value === "string") return value;
    if (typeof value === "object" && value?.address) return value.address;
    return "";
  };

  useEffect(() => {
    const initAutocomplete = () => {
      if (!window.google || !window.google.maps || !window.google.maps.places) {
        console.error("Google Maps JavaScript API not loaded");
        return;
      }

      const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
        types: ["geocode"],
        fields: ["formatted_address", "geometry", "place_id"],
      });

      autocompleteRef.current = autocomplete;

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (place.formatted_address && place.geometry) {
          const formattedLocation = {
            address: place.formatted_address,
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
            placeId: place.place_id,
          };

          setLocationData(formattedLocation);
          if (onChange) onChange(formattedLocation);
        }
      });
    };

    initAutocomplete();
  }, [onChange]);

  useEffect(() => {
    // If the value is an object, store for preview
    if (typeof value === "object" && value?.lat && value?.lng) {
      setLocationData(value);
    }
  }, [value]);

  return (
    <Box>
      <TextField
        label={label + (required ? " *" : "")}
        inputRef={inputRef}
        fullWidth
        variant="outlined"
        defaultValue={getAddressFromValue()}
        error={!!error}
        helperText={error}
      />

      {locationData?.lat && locationData?.lng && (
        <Box mt={2}>
          <Typography variant="subtitle2">Map Preview:</Typography>
          <iframe
            title="Map Preview"
            width="100%"
            height="200"
            style={{ border: 0, borderRadius: 8, marginTop: 8 }}
            loading="lazy"
            allowFullScreen
            src={`https://www.google.com/maps/embed/v1/view?key=${GOOGLE_MAPS_API_KEY}&center=${locationData.lat},${locationData.lng}&zoom=15`}
          ></iframe>
        </Box>
      )}
    </Box>
  );
};

export default GooglePlacesInputComponent;